/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_ParticipantCashTransferRequestListDto_Wealthlane_AwardSettlementService_Application_Contracts } from '../models/Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_ParticipantCashTransferRequestListDto_Wealthlane_AwardSettlementService_Application_Contracts';
import type { Wealthlane_AwardSettlementService_Dtos_Common_IntDropdownDto } from '../models/Wealthlane_AwardSettlementService_Dtos_Common_IntDropdownDto';
import type { Wealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_ParticipantBalanceDataDto } from '../models/Wealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_ParticipantBalanceDataDto';
import type { Wealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_RequestCashTransferDto } from '../models/Wealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_RequestCashTransferDto';
import type { Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto } from '../models/Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ParticipantCashTransferServiceSharedService {

    /**
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardSettlementApiAppParticipantCashTransferServiceSharedCalculateAndUpdateAllParticipantCashBalance(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award-settlement/api/app/participant-cash-transfer-service-shared/calculate-and-update-all-participant-cash-balance',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param fromDate 
     * @param toDate 
     * @param filter 
     * @param transferTypeIds 
     * @param cashTransferStatusIds 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_ParticipantCashTransferRequestListDto_Wealthlane_AwardSettlementService_Application_Contracts OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppParticipantCashTransferServiceParticipantCashTransferRequestList(
fromDate?: string,
toDate?: string,
filter?: string,
transferTypeIds?: Array<number>,
cashTransferStatusIds?: Array<number>,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_ParticipantCashTransferRequestListDto_Wealthlane_AwardSettlementService_Application_Contracts> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/participant-cash-transfer-service/participant-cash-transfer-request-list',
            query: {
                'FromDate': fromDate,
                'ToDate': toDate,
                'Filter': filter,
                'TransferTypeIds': transferTypeIds,
                'CashTransferStatusIds': cashTransferStatusIds,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_ParticipantBalanceDataDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppParticipantCashTransferServiceCurrentBalanceForParticipant(): CancelablePromise<Wealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_ParticipantBalanceDataDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/participant-cash-transfer-service/current-balance-for-participant',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardSettlementService_Dtos_Common_IntDropdownDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppParticipantCashTransferServiceTransferTypes(): CancelablePromise<Array<Wealthlane_AwardSettlementService_Dtos_Common_IntDropdownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/participant-cash-transfer-service/transfer-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardSettlementService_Dtos_Common_IntDropdownDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppParticipantCashTransferServiceCashTransferStatus(): CancelablePromise<Array<Wealthlane_AwardSettlementService_Dtos_Common_IntDropdownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/participant-cash-transfer-service/cash-transfer-status',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardSettlementService_Dtos_Common_IntDropdownDto OK
     * @throws ApiError
     */
    public static getApiAwardSettlementApiAppParticipantCashTransferServiceCashTransferCancelStatus(): CancelablePromise<Array<Wealthlane_AwardSettlementService_Dtos_Common_IntDropdownDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award-settlement/api/app/participant-cash-transfer-service/cash-transfer-cancel-status',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardSettlementApiAppParticipantCashTransferServiceRequestCashTransfer(
requestBody?: Wealthlane_AwardSettlementService_Dtos_ParticipantCashBalance_RequestCashTransferDto,
): CancelablePromise<Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award-settlement/api/app/participant-cash-transfer-service/request-cash-transfer',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transactionId 
     * @returns Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardSettlementApiAppParticipantCashTransferServiceCancelCashTransaction(
transactionId: string,
): CancelablePromise<Wealthlane_AwardSettlementService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award-settlement/api/app/participant-cash-transfer-service/cancel-cash-transaction/{transactionId}',
            path: {
                'transactionId': transactionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
